import { siteInfo } from '@/mocks/homeData';
import ImageBox from '@/components/base/ImageBox';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -right-24 w-[500px] h-[500px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-[600px] h-[600px] rounded-full bg-accent-50/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-0">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold tracking-wide mb-5">
              <i className="ri-fire-line"></i>
              {siteInfo.tag}
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-tight font-heading mb-4">
              {siteInfo.heading}
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-6">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-extrabold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={siteInfo.primaryCta.href}
                onClick={(e) => handleClick(e, siteInfo.primaryCta.href)}
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                {siteInfo.primaryCta.label}
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href={siteInfo.secondaryCta.href}
                onClick={(e) => handleClick(e, siteInfo.secondaryCta.href)}
                className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-background-300 text-foreground-700 font-semibold text-sm hover:border-primary-300 hover:text-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                {siteInfo.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[540px]">
            <ImageBox
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20representing%20entertainment%20news%20and%20celebrity%20gossip%20culture%20with%20warm%20coral%20and%20amber%20tones%2C%20dynamic%20overlapping%20geometric%20shapes%20with%20subtle%20newspaper%20and%20magazine%20texture%20elements%2C%20modern%20clean%20editorial%20aesthetic%20with%20soft%20lighting%2C%20stylized%20contemporary%20design%2C%20no%20text%20or%20people%2C%20sophisticated%20visual%20art%20piece%20for%20website%20hero%20background&width=1080&height=810&seq=hero-visual-2026&orientation=landscape"
              alt="吃瓜网51 - 最新最全的吃瓜爆料平台"
              title="吃瓜网51官网首页主视觉"
              className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100"
              imgClassName="w-full h-full object-cover object-top"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent rounded-2xl"></div>
            </ImageBox>
          </div>
        </div>
      </div>
    </section>
  );
}